import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import { resetImportProducts } from './other/actions';

const CustomPaper = styled(Paper)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-item: center;
  text-align: center;
  font-size: 1.2em;
  margin-top: 5%;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-item: center;
  justify-content: center;
  margin-top: 40px;
`;
/**
 * Component qui s'affiche quand les produits sont ajoutées dans le stock
 */
const CreateStockBatchSuccess = ({
  products,
  dispatchResetImportProducts,
  productIsInStock,
  history
}) => (
  <>
    <CustomPaper>
      <p>
        Vous avez importé{' '}
        <strong style={{ fontWeight: 700 }}>{products.length}</strong> produits.
      </p>
      {productIsInStock ? (
        <p>
          Vous nous avez indiqué que vos produits sont présents dans nos
          entrepôts, vous pouvez retrouver vos produits dans la partie gestion
          de stock.
        </p>
      ) : (
        <p>
          Afin que les commandes qui contiennent ses produits soient traitées
          vous devez
          <strong style={{ fontWeight: 700, color: '#d9534f' }}>
            &nbsp; impérativement faire une demande de traitement &nbsp;
          </strong>{' '}
          sur la page colis prêt.
        </p>
      )}
    </CustomPaper>
    <ButtonContainer>
      <Button
        color="primary"
        variant="contained"
        style={{ marginRight: 30 }}
        onClick={dispatchResetImportProducts}
      >
        Importer un nouveau fichier
      </Button>
      <Button
        color="primary"
        variant="contained"
        style={{ marginLeft: 30 }}
        onClick={() => {
          if (productIsInStock) {
            return history.push('/stock');
          }
          return history.push('/not-sent');
        }}
      >
        {productIsInStock ? 'Voir mon stock' : 'Voir mes colis prêts'}
      </Button>
    </ButtonContainer>
  </>
);

const mapStateToProps = state => ({
  products: state.importProducts.products,
  productIsInStock: state.importProducts.productIsInStock
});

const mapDispatchToProps = dispatch => ({
  dispatchResetImportProducts: () => dispatch(resetImportProducts())
});

CreateStockBatchSuccess.propTypes = {
  products: PropTypes.array.isRequired,
  productIsInStock: PropTypes.bool.isRequired,
  dispatchResetImportProducts: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateStockBatchSuccess));
